import { StyleSheet } from 'aphrodite';
import TileBackgroundImageUrl from '../../../assets/surveyTileBackground.png';
import { THEME } from '../../../components-v2/Theme/theme';
import { destructive, titles, white } from '../../../styles/colors';
import { CssSelectors } from '../../../styles/styles';

const {
	typography: { fontSizes },
	spacing,
	colors,
	common,
} = THEME;

export const styleSheet = StyleSheet.create({
	controllerWrapper: {
		width: '100%',
		maxWidth: 600,
		display: 'flex',
		flexDirection: 'column',
	},
	minimumDonationAmountInput: {
		width: 120,
	},
	separator: {
		marginTop: spacing.md,
		// marginBottom: spacing.md,
	},
	surveySettingsContainer: {
		marginBottom: spacing.sm,
		paddingInline: spacing.xl,
		paddingTop: spacing.xxl,
		height: '100% !important',
		boxSizing: 'border-box',
	},
	addOptionButton: {
		justifyContent: 'flex-start',
	},
	surveySettingsTabRoot: {
		background: THEME.colors.background.light,
		padding: spacing.md,
		borderRadius: common.borderRadius,
	},
	donationSurveyContainer: {
		boxSizing: 'border-box',
		color: titles,
		display: 'flex',
		flexDirection: 'column',
		fontSize: fontSizes.sm,
		width: '100%',
		background: THEME.colors.background.light,
	},
	header: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		padding: `${spacing.md}px ${spacing.md}px ${spacing.md}px 0`,
	},
	section: {
		padding: `${spacing.md}px ${spacing.md}px 0`,
		...CssSelectors.allChildren(
			{
				marginBottom: spacing.md,
			},
			':not(:last-child)'
		),
	},
	sectionTitle: {
		color: titles,
		fontSize: fontSizes.lg,
		fontWeight: 600,
		margin: 0,
	},
	donationOptionsTitle: {
		margin: `${spacing.md}px ${spacing.md}px 0 !important`,
	},
	tabViewContainer: {
		position: 'relative',
		zIndex: 1,
		height: `100%`,
	},
	tabList: {
		position: 'relative',
		zIndex: 1,
		background: white,
		display: 'flex',
		flexDirection: 'row',
		gap: spacing.sm,
		minHeight: spacing.xl,
		paddingInline: spacing.md,
		boxSizing: 'border-box',
		...CssSelectors.allDescendants(
			{
				width: 'auto',
				flex: 0,
				textTransform: 'capitalize',
				fontSize: fontSizes.sm,
				padding: `${spacing.sm}px ${spacing.md}px`,
				display: 'flex',
				alignItems: 'center',
			},
			'button'
		),
	},
	tabTextError: {
		color: `${destructive} !important`,
	},
	bodyBackground: {
		backgroundImage: `url(${TileBackgroundImageUrl})`,
		backgroundRepeat: 'repeat',
		backgroundSize: 60,
		bottom: 0,
		content: '',
		display: 'block',
		height: '100%',
		left: 0,
		opacity: 0.2,
		position: 'absolute',
		right: 0,
		top: 0,
		width: '100%',
		zIndex: 0,
	},
	formContainer: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		justifyContent: 'flex-start',
		width: '100%',
		alignItems: 'center',
		padding: '40px 0',
	},
	additionalQuestionsContainer: {
		width: '100%',
		maxWidth: 766,
		position: 'relative',
		zIndex: 1,
	},
	tabContent: {
		background: THEME.colors.background.main,
		overflowY: 'auto',
		flexGrow: 1,
	},
	tabContentLight: {
		background: THEME.colors.background.light,
	},
	newTabContent: {
		flexGrow: 1,
	},
	page: {
		background: THEME.colors.background.light,
		padding: '0 !important',
	},
	formSection: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.lg,
	},
	formField: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
	},
	formFieldSelect: {
		display: 'grid',
		gridTemplateColumns: '1fr 170px',
		gap: spacing.md,
	},
	formFieldLabelContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.xs,
	},
	formFieldLabelWithToggleContainer: {
		display: 'flex',
		flexDirection: 'row',
		gap: spacing.xs,
		justifyContent: 'space-between',
	},
	formFieldLabel: {
		color: colors.text.main,
		fontSize: fontSizes.sm,
		fontWeight: 500,
	},
	formFieldDescription: {
		color: colors.text.light,
		fontSize: fontSizes.xs,
		lineHeight: 1.5,
	},
	donationValuesContainer: {
		display: 'flex',
		gap: spacing.sm,
		flexWrap: 'wrap',
	},
	donationValue: {
		cursor: 'pointer',
		maxWidth: 120,
	},
	donationValueContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: spacing.sm,
	},
	serviceFeeCalculationMethodContainer: {
		display: 'grid',
		gridTemplateColumns: '200px 200px',
		gap: spacing.md,
	},
	errorMessage: {
		color: colors.danger.main,
		fontSize: fontSizes.sm,
	},
	fullWidth: {
		width: '100% !important',
	},
	relative: {
		position: 'relative',
	},
	causeDetailsTextArea: {
		backgroundColor: 'transparent',
		minHeight: '4lh',
		boxSizing: 'content-box',
		width: 'calc(100% - 24px)',
	},
	causeDetailsTextAreaContainer: {
		width: '100%',
		maxWidth: 600,
		flexDirection: 'column',
	},
	selectedCampaignsList: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: spacing.xs,
		marginBottom: spacing.sm,
	},
	campaignBadgeWrapper: {
		position: 'relative',
		display: 'inline-flex',
		alignItems: 'center',
		':hover .campaign-badge-remove': {
			opacity: 1,
		},
	},
	campaignBadgeRemove: {
		position: 'absolute',
		top: -6,
		right: -6,
		width: 16,
		height: 16,
		borderRadius: '50%',
		backgroundColor: colors.text.light,
		border: 'none',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		cursor: 'pointer',
		padding: 0,
		opacity: 0,
		transition: 'opacity 0.2s ease-in-out, background-color 0.2s ease-in-out',
		':hover': {
			backgroundColor: colors.text.main,
		},
	},
	campaignSearchWrapper: {
		width: '100% !important' as any,
	},
	campaignControllerSearchWrapper: {
		width: '100%',
		maxWidth: 600,
		position: 'relative',
		flexDirection: 'column',
		gap: spacing.sm,
		marginTop: `-${spacing.md}px`,
	},
	campaignControllerSearchContainer: {
		marginTop: 0,
	},
	campaignSearchDropdown: {
		position: 'absolute !important' as any,
		width: 'calc(100% - 26px)' as any,
		left: 0,
		marginTop: '0 !important' as any,
		top: '100% !important' as any,
		borderTop: 'none !important' as any,
		borderTopRightRadius: 0,
	},
	selectTrigger: {
		width: 170,
	},
	dateInputHasExpirationDateContainer: {
		marginBottom: 0,
	},
	dateInputWrapper: {
		width: '100%',
		maxWidth: 600,
		flexDirection: 'column',
	},
	dateInputContainer: {
		margin: 0,
	},
	notificationSection: {
		marginBottom: spacing.xxxl,
	},
	notificationSettingsContainer: {
		display: 'flex',
		flexDirection: 'row',
		gap: spacing.md,
		justifyContent: 'space-between',
		marginTop: spacing.md,
		marginBottom: spacing.lg,
		...CssSelectors.allChildren(
			{
				width: '100%',
				paddingLeft: `${spacing.xs}px`,
			},
			'div'
		),
	},
	notificationEmail: {
		width: '100%',
		minWidth: 417,
		...CssSelectors.allChildren(
			{
				':hover': {
					cursor: 'not-allowed',
				},
			},
			'input'
		),
	},
	notificationRecipientInput: {
		width: '100%',
		...CssSelectors.allChildren(
			{
				width: '100%',
			},
			'input'
		),
	},
	additionalRecipientsLabel: {
		display: 'block',
		marginBottom: spacing.sm,
		color: colors.text.light,
	},
	additionalRecipient: {
		marginBottom: spacing.md,
		minWidth: 417,
		...CssSelectors.allDescendants(
			{
				...CssSelectors.allChildren(
					{
						width: '100%',
					},
					'div:first-child'
				),
			},
			'div'
		),
	},
	removeButton: {
		color: colors.text.main,
		...CssSelectors.allChildren(
			{
				...CssSelectors.allDescendants(
					{
						color: 'transparent',
						fontSize: fontSizes.none,
					},
					'span'
				),
			},
			'span'
		),
	},
	removeButtonIcon: {
		width: 16,
		height: 16,
		color: colors.text.light,
	},
	fieldset: {
		border: spacing.none,
		margin: spacing.none,
		padding: spacing.none,
		boxSizing: 'border-box',
	},
	fieldsetDisabled: {
		opacity: 0.7,
		pointerEvents: 'none',
	},
	formControl: {
		margin: '0 0 16px',
		textAlign: 'left',
		width: '100%',
		...CssSelectors.allChildren(
			{
				width: '100%',
				display: 'block',
				marginBottom: spacing.sm,
				color: colors.text.light,
			},
			'label'
		),
	},
	noMargin: {
		margin: 0,
	},
});
